import { FC } from 'react'
import cx from 'classnames'

import { PictureProps } from '../Picture'
import { LinkProps } from '../Link'
import { Icons } from '../Icon'
import { colors } from '../../theme'

import * as SC from './styled'

export type ActionCardProps = MinimalSeoBlock & {
  className?: string
  pictureProps: PictureProps
  linkProps: LinkProps
  apectRatio?: number
  color?: string
}

const ActionCard: FC<ActionCardProps> = ({
  className,
  htmlTag,
  pictureProps,
  linkProps,
  apectRatio = 1,
  // utilisée pour les hovers
  color = colors.blueLight,
}) => {
  return (
    <SC.Container
      className={cx('ActionCard', className)}
      {...linkProps}
      $apectRatio={apectRatio}
      as={htmlTag}
    >
      <SC._Picture {...pictureProps} />
      {linkProps.href && (
        <SC.Label
          $color={color}
          $noText={linkProps.label || linkProps.text ? false : true}
        >
          {linkProps.label ?? linkProps.text}
          <SC._Icon icon={Icons.arrowRight} />
        </SC.Label>
      )}
    </SC.Container>
  )
}

export default ActionCard
